import React, { useState, useEffect } from 'react';

const DropdownView = ({ categories, activeCategoryIndex }) => {
  const defaultDictionary = {
    Blogs: {
      Categories: 'Choose category'
    },
  };
  const [dictionaryItem, setDictionaryItem] = useState(defaultDictionary.Blogs.Categories);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownItems, setDropdownItems] = useState([]);
  useEffect(() => {
    getDictionaryItem();
  }, []);
  useEffect(() => {
    getDropdownItems();
  }, [activeCategoryIndex]);
  const getDictionaryItem = () => {
    const theLang = document.documentElement.lang;
    DGS.Dictionary.getInstance().getTexts(defaultDictionary, () => {
      setDictionaryItem(defaultDictionary.Blogs.Categories);
    }, theLang);
  };
  const getDropdownItems = () => {
    const data = [...categories];
    data.splice(activeCategoryIndex, 1);
    setDropdownItems(data);
  };
  const toggleDropdownOnClick = () => {
    setIsDropdownOpen(prev => !prev);
  };
  return (
    <div className={`blog-categories-dropdown ${isDropdownOpen ? 'open' : ''}`}>
      <div className={`blog-categories-dropdown-btn-container`}>
        <button
          type="button"
          className="toggle-button"
          aria-expanded={isDropdownOpen}
          aria-controls="blog-categories-dropdown-menu"
          onClick={toggleDropdownOnClick}
          dangerouslySetInnerHTML={{ __html: dictionaryItem }}
        />
        {
          activeCategoryIndex !== 0 &&
          <a
            className="active-category-button"
            dangerouslySetInnerHTML={{ __html: categories[activeCategoryIndex].content }}
            href={categories[0].href}
          />
        }
      </div>
      {
        isDropdownOpen &&
        <div className="blog-categories-dropdown-menu" id="blog-categories-dropdown-menu">
          <div className="blog-categories-dropdown-menu-container">
            {dropdownItems.map((category, index) => (
              <a
                key={index}
                className={`blog-categories-dropdown-item`}
                href={category.href}
              >
                <span dangerouslySetInnerHTML={{ __html: category.content }}/>
              </a>
            ))}
          </div>
        </div>
      }
    </div>
  );
};

export default DropdownView;
